import './SpecialListArt.css';

const SpecialListArt: React.FC<{ type: 'starred' | 'read-later' }> = ({ type }) => {
  if (type == 'starred') {
    return (
      <svg className="specialListArt starArt" width="144" height="144" viewBox="0 0 144 144" aria-hidden="true">
        <defs>
          <radialGradient id="starGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#ffe89a" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#ffe89a" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="starFill" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffd86c" />
            <stop offset="100%" stopColor="#f5a623" />
          </linearGradient>
        </defs>
        <circle cx="72" cy="72" r="58" fill="url(#starGlow)" className="specialListGlow" />
        <path
          d="M72 24 L84.8 50.1 L113.6 54.3 L92.8 74.6 L97.7 103.2 L72 89.7 L46.3 103.2 L51.2 74.6 L30.4 54.3 L59.2 50.1 Z"
          fill="url(#starFill)"
          stroke="#e09d14"
          strokeWidth="3"
          strokeLinejoin="round"
          className="specialListShape"
        />
      </svg>
    );
  }

  return (
    <svg className="specialListArt clockArt" width="144" height="144" viewBox="0 0 144 144" aria-hidden="true">
      <defs>
        <radialGradient id="clockGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#9fd0ff" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#9fd0ff" stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx="72" cy="72" r="56" fill="url(#clockGlow)" className="specialListGlow" />
      <circle cx="72" cy="72" r="38" fill="#f7fbff" stroke="#4a90d9" strokeWidth="5" className="specialListShape" />
      <line x1="72" y1="72" x2="72" y2="49" stroke="#3a7bc0" strokeWidth="5" strokeLinecap="round" className="clockHandHour" />
      <line x1="72" y1="72" x2="89" y2="79" stroke="#2f6fb2" strokeWidth="4" strokeLinecap="round" className="clockHandMinute" />
      <circle cx="72" cy="72" r="4" fill="#2f6fb2" />
    </svg>
  );
};

export default SpecialListArt;
